import Button from './Button';
import TooltipBody from '../Tooltip';
import Typography from '../text/Typography';
import { Placement } from '@popperjs/core';
import { ButtonHTMLAttributes, FunctionComponent } from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import styled from 'styled-components';

export const StyledPaperButton = styled(Button)`
	width: ${(p) => p.width ? p.width : '100%'};
	height: ${(p) => p.height ? p.height : '100%'};
	border: none;
	background-color: ${(p) => p.theme.palette.darkBaby};
	padding: ${(p) => p.theme.spacing(1)};
	&:hover {
		background-color: ${(p) => p.theme.palette.darkBaby};
	}
`;
	// display: flex;
	// justify-content: center;
	// align-items: center;

interface PaperButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	tooltip?: string;
	width?: string;
	height?: string;
	showTooltip?: boolean;
	tooltipPlacement?: Placement;
}

const PaperButton: FunctionComponent<PaperButtonProps> = ({
	tooltip,
	width,
	height,
	showTooltip = true,
	children,
	tooltipPlacement,
	...restProps
}) => {
	const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
		usePopperTooltip({ placement: tooltipPlacement ?? 'auto' });

	const doShowTooltip = showTooltip ?? tooltip ? true : false;

	return (
		<>
			<StyledPaperButton
				width={width}
				height={height}
				{...restProps}
				className='unselectable'
				ref={setTriggerRef as any}>
				{children}
			</StyledPaperButton>
			{tooltip && visible && doShowTooltip && (
				<TooltipBody {...getTooltipProps()} ref={setTooltipRef as any}>
					<Typography
						className='unselectable'
						variant='caption2'
						style={{ whiteSpace: 'nowrap'}}
					>
						{tooltip}
					</Typography>
				</TooltipBody>
			)}
		</>
	);
};
export default PaperButton;
